// Paysol i18n — tiny hand-rolled translator.
// Usage in components:
//   import { t, currentLocale, setLocale } from '@/i18n';
//   {{ t('landing.hero.title') }}
// Reactive: components can watch `currentLocale.value` (Vue 3 ref) or listen for the `paysol-locale-changed` event.

import { ref } from 'vue';
import en from './en.json';
import sw from './sw.json';

const DICTS = { en, sw };
const STORAGE_KEY = 'paysol_locale';

function detect() {
  if (typeof window === 'undefined') return 'en';
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && DICTS[stored]) return stored;
  } catch (e) { /* silent */ }
  const nav = (navigator.language || 'en').toLowerCase();
  if (nav.startsWith('sw')) return 'sw';
  return 'en';
}

export const currentLocale = ref(detect());
if (typeof document !== 'undefined') document.documentElement.lang = currentLocale.value;

export function setLocale(loc) {
  if (!DICTS[loc]) return;
  currentLocale.value = loc;
  try { localStorage.setItem(STORAGE_KEY, loc); } catch (e) { /* silent */ }
  if (typeof document !== 'undefined') document.documentElement.lang = loc;
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('paysol-locale-changed', { detail: loc }));
}

function walk(dict, key) {
  const parts = key.split('.');
  let cur = dict;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

/** t('landing.hero.title', { name: 'Alex' }) → interpolates {name} */
export function t(key, vars = {}) {
  const dict = DICTS[currentLocale.value] || DICTS.en;
  let val = walk(dict, key);
  if (val == null) {
    // Fallback to English if the current locale is missing the key
    val = walk(DICTS.en, key);
    if (val == null) return key;   // last resort: return the key itself
  }
  if (typeof val !== 'string') return key;
  return val.replace(/\{(\w+)\}/g, (_, name) => (vars[name] != null ? String(vars[name]) : `{${name}}`));
}

/** List of supported locales for pickers */
export const availableLocales = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'sw', label: 'Kiswahili', flag: '🇰🇪' },
];
